/**
 * The VOCABULARY slice of the Admin surface: platforms, stacks, and one country's
 * platform availability (migrations 38/39; owner rulings Q8/Q8-b, D-2, D-2b).
 *
 * Named `routes.vocabulary.tsx` for the reason `routes.tax.tsx` records — one route
 * array per work stream, meeting only in `src/routes.extra.ts`, so streams never
 * race for one filename.
 *
 * ⚠ ALL THREE ARE `/countries/:cc/admin/…`, AND FOR THE FIRST TWO THE `:cc` SCOPES
 * THE CHROME, NOT THE DATA — the `routes.roles.tsx` shape: `platforms` and `stacks`
 * carry no `country_id`, the API routes behind those screens carry no `:cc`
 * (`/admin/platforms`, `/admin/stacks`), and switching country does not change the
 * list. The THIRD is genuinely country-scoped: `platform-availability` reads and
 * writes `/countries/:cc/platforms`, so the country in the URL is the country whose
 * answer is being edited.
 *
 * There is deliberately NO `admin/stack-availability`: `/countries/:cc/stacks` does
 * not exist and must not (D-2b — `stacks.controller.ts:9-20`).
 *
 * The screens use inline alerts rather than the inquiries toast, so no provider
 * layout route is needed — the infra slice's precedent.
 */

import type { RouteObject } from 'react-router-dom';
import { PlatformsPage } from './PlatformsPage';
import { StacksPage } from './StacksPage';
import { PlatformAvailabilityPage } from './PlatformAvailabilityPage';

export const adminVocabularyRoutes: RouteObject[] = [
  { path: 'admin/platforms', element: <PlatformsPage /> },
  { path: 'admin/stacks', element: <StacksPage /> },
  { path: 'admin/platform-availability', element: <PlatformAvailabilityPage /> },
];
